<template>
    <div
        style="
            height: 970px;
            background-repeat: no-repeat;
            background-size: 1178px 634px;
            background-image: url(https://img.uelink.com.cn/upload/xin_li_monitor/bg_img.png);
            background-position: center;
            background-attachment: fixed;
        "
    >
    <div class="dialog" v-if="isShowDialog">
        <div class="box">
            <div class="close" @click="handleClose">x</div>
             <p class="title">请校对{{testerTypeId === 1?'学生':'教师'}}信息</p>
            <div class="content">
                <p>学校 ：{{orgName}}</p>
                <p v-if="needProfile === 1&&testerTypeId === 1">学籍号 ：{{studentList.sn}}</p>
                <p v-if="addType == 1">姓名 ：{{newTrueName&&newTrueName.includes('*') ? this.newName : newTrueName}}</p>
                <p v-else>姓名 ：{{studentList.trueName}}</p>
                <template v-if="testerTypeId === 1">
                    <p>年级 ：{{grade[studentList.grade] || studentList.grade + '级'}}</p>
                    <p>班级 ：{{studentList.studyClass}}</p>
                </template>
                <p>年龄 ：{{age}}</p>
                <p>性别 ：{{studentList.gender==0?'女':'男'}}</p>
                <div style="margin-top: 30px;">
                    <i class="icon">i</i><span class="hint">信息不符请{{testerTypeId === 1?'检查学籍号是否正确或反馈班主任':'联系技术人员'}}</span>
                </div>
            </div>
            <div style="display: flex;" v-if="lastProgress && (lastProgress > 0)">
                <button class="goBtn" @click="gotoTest(1)"> 重新测试 </button>
                <button class="goBtn" style="margin-left: 30px;" @click="gotoTest(2)"> 继续测试 {{ lastProgress }}% </button>
            </div>
            <template v-else>
                <button class="goBtn" @click="goEva">信息无误，进入测评</button>
                <!-- <button class="goBtn" @click="perfectFile">完善学生档案</button> -->
            </template>
        </div>
    </div>
    <div class="dialog" v-if="selectShowDialog">
        <div class="box">
            <div class="close" @click="selectShowDialog = false">x</div>
             <p class="title">请选择学生信息</p>
            <div 
                :class="['content', info.sn === item.sn ?'skyblue':'']" 
                v-for="item in profiles" :key="item.id"
                @click="select(item)"
            >
                <p>学籍号 ：{{item.sn}}</p>
                <p>姓名 ：{{item.trueName}}</p>
                <p>性别 ：{{item.gender==0?'女':'男'}}</p>
            </div>
            <div style="margin-top: 30px;">
                <i class="icon">i</i><span class="hint">信息不符请检查学籍号是否正确或反馈班主任</span>
            </div>
            <button class="goBtn" @click="affirm">确认</button>
        </div>
    </div>
        <div
            style="
                position: fixed;
                top: 50%;
                left: 50%;
                margin-top: -260px;
                margin-left: -288px;
            "
        >
            <div class="page_xyfx">
                <div class="page-box">
                    <div
                        class="box"
                        style="
                            width: 600px;
                            margin: 7px auto 11px;
                            padding: 35px 70px;
                        "
                    >
                        <van-form @submit="onSubmit" style="width: 100%">
                            <div
                                class="tit"
                                style="font-size: 24px; margin-bottom: 30px"
                            >
                                填写你的信息
                            </div>
                            <div
                                style="
                                    font-size: 15px;
                                    font-family: PingFang SC;
                                    font-weight: 600;
                                    line-height: 21px;
                                    display: flex;
                                    color: #62666c;
                                "
                            >
                            <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        学校:
                                    </div>
                                    <select
                                        v-model="info.examId"
                                        class="input_box"
                                        style="
                                            border: 1px solid #cbcdd1;
                                            padding: 10px;
                                            margin-left: 20px;
                                            border-radius: 4px;
                                        "
                                    >
                                        <option
                                            :value="examList.id"
                                            :label="orgName"
                                        />
                                    </select>
                            </div>
                            
                                <div
                                    v-if="addType === 1"
                                    style="
                                        font-size: 15px;
                                        font-family: PingFang SC;
                                        font-weight: 600;
                                        line-height: 21px;
                                        display: flex;
                                        color: #62666c;
                                        margin-top: 20px;
                                    "
                                >
                                    <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        学籍号:
                                    </div>
                                    <input
                                        v-model="info.sn"
                                        class="input_box"
                                        style="
                                            border: 1px solid #cbcdd1;
                                            padding: 10px;
                                            margin-left: 20px;
                                            border-radius: 4px;
                                        "
                                        placeholder="请输入学籍号"
                                    />
                                </div>
                            
                                <div
                                    style="
                                        font-size: 15px;
                                        font-family: PingFang SC;
                                        font-weight: 600;
                                        line-height: 21px;
                                        display: flex;
                                        color: #62666c;
                                        margin-top: 20px;
                                    "
                                >
                                    <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        姓名:
                                    </div>
                                    <input
                                        v-model="info.name"
                                        class="input_box"
                                        style="
                                            border: 1px solid #cbcdd1;
                                            padding: 10px;
                                            margin-left: 20px;
                                            border-radius: 4px;
                                        "
                                        placeholder="请输入姓名"
                                    />
                                </div>
                            <template v-if="testerTypeId === 1">
                                <div
                                    v-if="areaList.length > 0"
                                    style="
                                        font-size: 15px;
                                        font-family: PingFang SC;
                                        font-weight: 600;
                                        line-height: 21px;
                                        display: flex;
                                        color: #62666c;
                                        margin-top: 20px;
                                    "
                                >
                                    <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        校区:
                                        </div>
                                            <select
                                                v-model="info.area"
                                                class="input_box"
                                                style="
                                                    border: 1px solid #cbcdd1;
                                                    padding: 10px;
                                                    margin-left: 20px;
                                                    border-radius: 4px;
                                                "
                                            >
                                                <option
                                                    v-for="(
                                                        area, areaIndex
                                                    ) in areaList"
                                                    :key="areaIndex"
                                                    :value="area.area"
                                                >
                                                    {{ area.area }}
                                                </option>
                                            </select>
                                    </div>
                                <div
                                    style="
                                        font-size: 15px;
                                        font-family: PingFang SC;
                                        font-weight: 600;
                                        line-height: 21px;
                                        display: flex;
                                        color: #62666c;
                                        margin-top: 20px;
                                    "
                                >
                                    <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        年级:
                                    </div>
                                    <select
                                        v-model="info.grade"
                                        @change="onSelected($event)"
                                        class="input_box"
                                        style="
                                            border: 1px solid #cbcdd1;
                                            padding: 10px;
                                            margin-left: 20px;
                                            border-radius: 4px;
                                        "
                                    >
                                        <option
                                            v-for="(
                                                gra, gradeIndex
                                            ) in gradeList"
                                            :key="gradeIndex"
                                            :value="gra.value"
                                        >
                                            {{ gra.label }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    style="
                                        font-size: 15px;
                                        font-family: PingFang SC;
                                        font-weight: 600;
                                        line-height: 21px;
                                        display: flex;
                                        color: #62666c;
                                        margin-top: 20px;
                                    "
                                >
                                    <div
                                        style="
                                            flex: 2;
                                            align-self: center;
                                            text-align: right;
                                        "
                                    >
                                        班级:
                                    </div>
                                    <select
                                        v-model="info.studyClass"
                                        class="input_box"
                                        style="
                                            border: 1px solid #cbcdd1;
                                            padding: 10px;
                                            margin-left: 20px;
                                            border-radius: 4px;
                                        "
                                    >
                                        <option
                                            v-for="(sClass, index) in classList"
                                            :key="index"
                                            :label="sClass"
                                            :value="sClass"
                                        ></option>
                                    </select>
                                </div>
                            </template>

                            <div
                                style="
                                    font-size: 15px;
                                    font-family: PingFang SC;
                                    font-weight: 600;
                                    line-height: 21px;
                                    display: flex;
                                    color: #62666c;
                                    margin-top: 20px;
                                "
                            >
                                <div
                                    style="
                                        flex: 2;
                                        align-self: center;
                                        text-align: right;
                                    "
                                >
                                    年龄:
                                </div>
                                <input
                                    v-model="info.age"
                                    class="input_box"
                                    style="
                                        border: 1px solid #cbcdd1;
                                        padding: 10px;
                                        margin-left: 20px;
                                        border-radius: 4px;
                                    "
                                    type="number"
                                    placeholder="请输入年龄，如12"
                                />
                            </div>
                            <div
                                style="
                                    font-size: 15px;
                                    font-family: PingFang SC;
                                    font-weight: 600;
                                    line-height: 21px;
                                    display: flex;
                                    color: #62666c;
                                    margin-top: 20px;
                                "
                            >
                                <div
                                    style="
                                        flex: 2;
                                        align-self: center;
                                        text-align: right;
                                    "
                                >
                                    性别:
                                </div>
                                <div
                                    class="input_box"
                                    style="margin-left: 20px"
                                >
                                    <input
                                        type="radio"
                                        id="one"
                                        :value="1"
                                        v-model="info.gender"
                                        style="width: 20px; height: 20px"
                                    />
                                    <label
                                        style="
                                            position: absolute;
                                            margin-top: 3px;
                                            margin-left: 5px;
                                        "
                                        for="one"
                                        >男</label
                                    >
                                    <input
                                        type="radio"
                                        id="two"
                                        :value="0"
                                        v-model="info.gender"
                                        style="
                                            width: 20px;
                                            height: 20px;
                                            margin-left: 60px;
                                        "
                                    />
                                    <label
                                        style="
                                            position: absolute;
                                            margin-top: 3px;
                                            margin-left: 5px;
                                        "
                                        for="two"
                                        >女</label
                                    >
                                </div>
                            </div>
                            <button
                                class="btn"
                                style="
                                    height: 50px;
                                    line-height: 25px;
                                    font-size: 15px;
                                    border-radius: 25px;
                                    margin-top: 30px;
                                "
                                type="submit"
                            >
                                提交信息
                            </button>
                        </van-form>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {
        login,
        loginV2,
        examDetail,
        getExamDetail,
        // getGradeAndStudyClass,
        getGradeAndStudyClassV5,
        getAreasList,
        getProfilesByInfo,
        findProfilesByInfoSn,
        updateProfileName
    } from "@/api/api";
    import { mapGetters } from 'vuex'
    export default {
        data () {
            return {
                newTrueName: '',
                profileId: null,
                addType: 0,
                lastProgress: 0,
                selectShowDialog: false,
                profiles: [],
                testerTypeId: null,
                needProfile: null,
                selected: "",
                value: "",
                info: {
                    age:null,
                    sn:"",
                    examId:"",
                    gender: "",
                    grade: "",
                    studyClass: "",
                    name:"",
                    area: ""
                },
                showPicker: false,
                showPickerClass: false,
                examList:{},
                orgName:"",
                gList: [],
                areaList:[],
                gradeList:[],
                classList: [],
                isShowDialog:false,
                studentList:{},
                age:null,
                grade:['一年级','二年级','三年级','四年级','五年级','六年级','初一','初二','初三','高一','高二','高三']
            };
        },
        computed: {
            ...mapGetters(['orgId', 'examId'])
        },
        mounted () {
            var orgId = this.orgId
            if (!orgId || orgId == 'undefined') {
                this.$message.warning('未检测到学校')
                this.$router.go(-1)
                return
            }
            this.info.orgId = parseInt(orgId)
            this.info.examId = parseInt(this.examId)
            this.getAreaList();
            this.getGradeAndStudyClass()
            this.getExamDetail()
            this.getAreasList()
        },
        methods: {
            gotoTest(mode){
                if (mode == 1) {
                    this.$confirm('重新测试将清除之前的进度，清除后不可恢复，确定重新测试？', '警告', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        window.localStorage.removeItem('topics_' + this.studentId)
                        window.localStorage.removeItem('topicIndex_' + this.studentId)
                        window.localStorage.removeItem('topicProgress_' + this.studentId)
                        this.$router.push('/evaluation')
                    })
                } else {
                    this.$router.push('/evaluation?mode=2')
                }
            },
            // 获取校区
            getAreasList(){
                let orgId = this.orgId
                getAreasList({orgId,examId: this.examId}).then((res)=>{
                    this.areaList = res.data.list || []
                })
            },
            // 获取场次详情
            getAreaList () {
                let query = {
                    id: this.examId,
                };
                getExamDetail(query)
                    .then((res) => {
                        // console.log(res, "数据");
                        this.orgName=res.data.orgName
                        this.examList = res.data.exam;
                        this.testerTypeId = res.data.exam.testerTypeId
                        this.needProfile = res.data.exam.needProfile
                        this.addType = res.data.addType
                        const isFamilyType = res.data.isFamilyType

                        // 父母养育 测评量表状态 1：是， 0：否
                        window.localStorage.setItem("is_familyType", isFamilyType );
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            getExamDetail () {
                examDetail({ id: this.info.examId, token: 't' }).then(res => {
                    this.info.testerTypeId = res.data.exam.testerTypeId
                })
            },
            /**
             * 获取年级和班级
             */
            async getGradeAndStudyClass () {
                try {
                    // const qtOriginBool = this.$store.state.user.qtOriginBool
                    let query = {
                        examId: this.examId,
                    };
                    // let res
                    // if (qtOriginBool) {
                    //     res = await getGradeAndStudyClassV5(query)
                    // } else {
                    //     res = await getGradeAndStudyClassV5(query)
                    // }
                    const res = await getGradeAndStudyClassV5(query)
                    var list = res.data.list
                    var gList = []
                    list.forEach(ele => {
                        if (ele.gradeName.indexOf('段') !== -1) {
                            gList.push({
                                value: ele.grade,
                                label: ele.gradeName.split('段')[1]
                            })
                        } else {
                            gList.push({
                                value: ele.grade,
                                label: ele.gradeName
                            })
                        }
                    });
                    // console.log(gList);
                    this.gradeList = gList
                    this.gList = list
                } catch (error) {
                    console.log(error)
                }
            },
            // 关闭dialog
            handleClose(){
                this.isShowDialog=false

            },
            cs () {
                console.log("sss");
            },
            onSelected (e) {
                // console.log(e.target.value, e, "event值");
                this.info.grade = e.target.value;
                var cList = []
                this.gList.forEach(element => {
                    if (element.grade == e.target.value) {
                        element.studyClassList.forEach(e => {
                            cList.push(e.studyClass)
                        });
                    }


                });
                this.classList = cList
            },
            onConfirm (value) {
                this.value = value;
                this.gradeList.forEach((element) => {
                    if (element == value) {
                        this.info.grade = element.value;
                    }
                });

                this.showPicker = false;
            },
            onConfirmClass (value) {
                this.info.studyClass = value;
                this.showPickerClass = false;
            },
            onSubmit: function () {
                let info = JSON.parse(JSON.stringify(this.info))
                if (!info.examId) {
                    this.$notify("请选择学校！");
                    return false;
                }
                if (!info.sn && this.addType === 1) {
                    this.$notify("请输入学籍号！");
                    return false;
                }
                    if (!info.name) {
                        this.$notify("请输入姓名！");
                        return false;
                    }
                if (this.testerTypeId === 1) {
                    // if (this.areaList.length > 0 && !info.area) {
                    //     this.$notify("请选择校区！");
                    //     return false;
                    // }
                    if (!info.grade && info.gender !== 0) {
                        this.$notify("请选择年级！");
                        return false;
                    }
                    if (!info.studyClass) {
                        this.$notify("请选择班级！");
                        return false;
                    }
                }
                if (!info.age) {
                    this.$notify("请输入年龄！");
                    return false;
                }
                if (!info.gender && info.gender !== 0) {
                    this.$notify("请选择性别！");
                    return false;
                }
                if (!(/^\+?[1-9][0-9]*$/.test(info.age))) {
                    this.$notify("年龄格式不对！");
                    return false;
                }
                if (this.testerTypeId === 1 && this.needProfile === 1) {
                    if (this.addType === 1) {
                        this.newName = info.name
                        findProfilesByInfoSn({
                                token:'t',
                                examId: this.examId,
                                orgId: this.orgId,
                                sn: info.sn,
                                grade: info.grade,
                                studyClass: info.studyClass,
                                gender: info.gender
                            }).then(ret=>{
                                this.age= info.age
                                // 过滤已测学生
                                const studentNumNew = ret.data.profiles.length
                                const profiles = ret.data.profiles.filter(item=>item.testingStatus === 0)
                                const studentNum = profiles.length
                                this.profileId = ret.data.profiles[0].id
                                this.newTrueName = ret.data.profiles[0].trueName
                                // console.log(this.profileId);
                                
                            if (profiles.length < 1) {
                                if (studentNumNew) {
                                    this.$message.warning(`该学生已完成测试`)
                                } else {
                                    this.$message.warning(`查询不到该学生信息`)
                                }
                                return
                            }else{
                                if (studentNum >= 2) {
                                    this.profiles = profiles
                                    this.selectShowDialog = true
                                } else {
                                    this.info = profiles[0]
                                    this.info.age = this.age
                                    this.appraisal()
                                }
                            }
                        })
                    } else {
                        getProfilesByInfo({
                                token:'t',
                                examId: this.examId,
                                orgId: this.orgId,
                                trueName: info.name,
                                grade: info.grade,
                                studyClass: info.studyClass,
                                gender: info.gender
                            }).then(ret=>{
                                this.age= info.age
                                // 过滤已测学生
                                const studentNumNew = ret.data.profiles.length
                                const profiles = ret.data.profiles.filter(item=>item.testingStatus === 0)
                                const studentNum = profiles.length
                            if (profiles.length < 1) {
                                if (studentNumNew) {
                                    this.$message.warning(`该学生已完成测试`)
                                } else {
                                    this.$message.warning(`查询不到该学生信息`)
                                }
                                return
                            }else{
                                if (studentNum >= 2) {
                                    this.profiles = profiles
                                    this.selectShowDialog = true
                                } else {
                                    this.info = profiles[0]
                                    this.info.age = this.age
                                    this.appraisal()
                                }
                            }
                        })
                    }
                } else {
                    login(this.info).then((res)=>{
                            this.age= info.age
                            this.studentList.sn = info.sn
                            this.studentList.trueName = info.name
                            this.studentList.grade = info.grade
                            this.studentList.studyClass = info.studyClass
                            this.studentList.gender = info.gender
                            this.newTrueName = info.name
                            // this.$toast.success("提交成功");
                            window.localStorage.setItem("studentId", res.data.studentId);
                            window.localStorage.setItem("token", res.data.token);
                            //获取最后测评进度
                            this.lastProgress = window.localStorage.getItem(`topicProgress_${res.data.studentId}`) || 0
                            this.isShowDialog=true
                    })
                }
            },
            appraisal() {
                let data = {
                    examId: this.info.examId,
                    sn:this.info.sn,
                    age:this.age,
                    gender:this.info.gender
                };
                loginV2(data)
                    .then((res) => {
                        window.localStorage.setItem("studentId", res.data.studentId);
                        this.studentId = res.data.studentId
                        window.localStorage.setItem("token", res.data.token);
                        //获取最后测评进度
                        this.lastProgress = window.localStorage.getItem(`topicProgress_${res.data.studentId}`) || 0
                        this.studentList=res.data.profile
                        this.isShowDialog=true
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            affirm() {
                this.selectShowDialog = false
                this.appraisal()
            },
            select(info){
                this.info = info
                if (this.addType === 1) {
                    this.profileId = info.id
                    this.newTrueName = info.trueName
                }
            },
            perfectFile(){
                window.open('http://192.168.2.132:1230/sEdit/588751?type=2')
            },
            goEva() {
                if (this.addType === 1 && this.newTrueName.includes('*')) {
                    const data = {
                        token : window.localStorage.getItem("token"),
                        profileId: this.profileId,
                        trueName: this.newName
                    }
                    // console.log(data);
                    
                    updateProfileName(data).then(()=>{
                        this.$router.push('/evaluation')
                    })
                } else {
                    this.$router.push('/evaluation')
                }
            }
        },
    };
</script>
<style lang="less">
    .el-message-box{
        width: 90%;
    }
</style>
<style lang="less" scoped>
// 遮罩层
.dialog{
    position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background-color: rgba(90, 90, 90, 0.5);
	z-index: 1;
    .box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 3px;
        margin: 30px auto;
        width: 200px;
        background-color: #fff;
        padding: 20px 0;
        .close{
            font-size: 10px;
            color: #9d9999;
            text-align: center;
            position:absolute;
            line-height: 10px;
            top:2px;
            right: 2px;
            width: 10px;
            height: 10px;
            cursor: pointer;
        }
        .title{
            margin-top: 0.03667rem;
            padding: 0;
            height: 5px;
            font-size: 5px;
            text-align: center;
        }
        .content{
            text-align: center;
            font-size: 4px;
            padding: 3px 7px;
        }
        .skyblue{
            border-radius: 5px;
            background-color: skyblue;
        }
            .hint{
                margin-left: 1px;
                line-height: 5px;
                color: rgb(97, 94, 94);
                vertical-align: middle;
                }
                .icon{
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    color: #fff;
                    font-size: 3px;
                    border-radius: 2px;
                    text-align: center;
                    background-color: rgb(97, 94, 94);
            }
        .goBtn{
            min-width: 60px;
            margin: 0 auto;
            cursor: pointer;
            padding: 3px 5px;
            font-size: 4px;
            color:#fff;
            margin-top: 10px;
            border: #5a6ef9;
            background-color: #5a6ef9;
            border-radius: 1px;
            &:hover{
                background-color: #8e9cf5;
            }
        }
    }
}

  .input_box {
    background: #FFFFFF;
    opacity: 1;
    flex: 10;
  }

  .styleCss {
    margin-bottom: 10px;
  }

  .tit_class {
    height: 10px;
    line-height: 10px;
    font-size: 4px;
  }

  .checkIndex {
    width: 100%;
    box-sizing: border-box;
    height: 10px;
    line-height: 10px;
    background-color: #f1f1f1;
    border-radius: 5px;
    padding-left: 5px;
    font-size: 4px;
    border: 0px solid #f1f1f1;
  }

  .leftClass {
    font-size: 8px;
  }

  .bg,
  // .bottom-bg {
  //   background: #e2faff;
  // }

  .image {
    width: 100%;
    vertical-align: middle;
    margin-top: -1px;
  }

  .page_xyfx {
    // position: relative;
    box-sizing: border-box;

    .page-box {
      // box-sizing: border-box;

      // padding: 0 60px;

      .box {
        box-sizing: border-box;
        border-radius: 6px;
        background: #fff;

        // border: 2px solid #797faa;

        .tit {
          color: #6b7074;
          text-align: center;
          font-weight: bold;
        }

        .active-cell {
          position: static;
          box-sizing: border-box;
          padding: 0;
          margin-bottom: 10px;
          display: flex;
          align-items: flex-start;
          border: none;

          .van-cell--large .van-cell__title {
            font-size: 8px;
          }

          /deep/ .van-field__label {
            height: 10px;
            line-height: 10px;
            font-size: 4px;
          }

          /deep/ .van-field__control {
            box-sizing: border-box;
            height: 10px;
            line-height: 10px;
            background-color: #f1f1f1;
            border-radius: 5px;
            padding-left: 5px;
            font-size: 4px;
          }
        }

        .active-cell1 {
          position: static;
          box-sizing: border-box;
          padding: 0;
          display: flex;
          align-items: flex-start;
          border: none;

          .van-cell--large .van-cell__title {
            font-size: 4px;
          }

          /deep/ .van-field__label {
            height: 10px;
            line-height: 23px;
            font-size: 4px;
          }

          /deep/ .van-field__control {
            box-sizing: border-box;
            height: 10px;
            line-height: 10px;
            background-color: #ffffff;
            border-radius: 5px;
            padding-left: 5px;
            font-size: 4px;
          }
        }
      }

      .tip {
        font-size: 14px;
        color: #666;
        margin-top: 22px;
      }

      .btn {
        margin: 0;
        box-sizing: border-box;
        width: 100%;
        background: #5a6ef9;
        text-align: center;
        color: #fff;
        border: none;
        outline: none;
      }
    }
  }
</style>